/**
 * Social login networking — posts a provider credential to the backend
 * `POST /auth/social`, which returns the same `{ user, token }` (or 2FA
 * challenge) as `/auth/local`.
 */

import axios from 'axios';
import { ApiConfig } from '../config/ApiConfig';
import { getDeviceHeaders } from '../helpers/deviceInfo';

/**
 * @param {string} provider
 * @param {object} payload  { credential } | { accessToken } | { code, redirectUri } (+ firstName/lastName)
 * @returns {Promise<{status:number, data:any}>}
 */
export async function socialLogin(provider, payload = {}) {
    let deviceHeaders = {};

    try {
        deviceHeaders = await getDeviceHeaders();
    } catch (_e) {
        deviceHeaders = {};
    }

    const res = await axios.post(
        `${ApiConfig.apiURL}/auth/social`,
        { provider, ...payload },
        {
            headers: { 'Content-Type': 'application/json', ...deviceHeaders },
            timeout: 20000,
            validateStatus: () => true,
        },
    );

    return { status: res.status, data: res.data };
}

export default { socialLogin };
